<template>
  <base-tab
    :slug="slug"
    :label="label"
    @tab-click="$emit('tab-click', $event)"
    :class="[
      {
        'ps-text-gray-400 hover:ps-text-gray-800': !active,
        'ps-text-gray-800 ps-rounded-t-lg': active
      }
    ]"
    class="ps-relative ps-pt-2 ps-uppercase ps-h-10 ps-rounded-none ps-overflow-visible  ps-rounded-none ps-shadow-none hover:ps-shadow-none"
  >
    <svg-icon
      :name="iconName"
      width="24"
      class="ps-svg-stroke-two"
      height="auto"
    ></svg-icon>
    <span
      v-if="isComments"
      class="ps-absolute ps-text-xxs ps-leading-none ps-top-0 ps-right-0 ps-m-2  ps-mr-3  ps-w-4 ps-h-4 ps-bg-white ps-text-brand-brown ps-rounded-full ps-inline-flex ps-items-center ps-justify-center ps-font-extrabold "
      >{{ commentsCount }}</span
    >
    <span
      v-if="isPages"
      class="ps-absolute ps-text-xxs ps-leading-none ps-top-0 ps-right-0 ps-m-2 ps-mr-3  ps-w-4 ps-h-4 ps-bg-white ps-text-brand-brown ps-rounded-full ps-inline-flex ps-items-center ps-justify-center ps-font-extrabold "
      >{{ pagesCount }}</span
    >
    <span
      v-if="isBrowsers"
      class="ps-absolute ps-text-xxs ps-leading-none ps-top-0 ps-right-0 ps-m-2 ps-mr-3  ps-w-4 ps-h-4 ps-bg-white ps-text-brand-brown ps-rounded-full ps-inline-flex ps-items-center ps-justify-center ps-font-extrabold "
      >{{ browsersCount }}</span
    >
    <div
      v-if="active"
      class="ps-absolute  ps-left-0 ps-bottom-0 ps-border-b-2 ps-border-solid ps-border-gray-600 ps--mb-2 ps-w-full"
    ></div>
  </base-tab>
</template>

<script>
import BaseTab from '@/components/BaseTab'
export default {
  name: 'TabRounded',
  props: {
    slug: String,
    label: String,
    active: Boolean,
    commentsCount: {
      type: Number,
      default: 0
    },
    pagesCount: {
      type: Number,
      default: 0
    },
    browsersCount: {
      type: Number,
      default: 0
    }
  },
  components: {
    BaseTab
  },
  computed: {
    isComments() {
      return this.slug === 'comments' && this.commentsCount > 0
    },
    isPages() {
      return this.slug === 'pages' && this.pagesCount > 0
    },
    isBrowsers() {
      return this.slug === 'browsers' && this.browsersCount > 0
    },
    iconName() {
      return `card-${this.slug}`
    },
    iconSize() {
      if (this.isComments) {
        return '25'
      }
      return '20'
    }
  }
}
</script>
